import { IGroupPolicySearchParams } from './interface';

export const HEAD_TABLE_PROPS = [
  { id: 'id', label: 'ID', align: 'center' },
  { id: 'name', label: 'Tên nhóm quyền', align: 'center' },
  { id: 'description', label: 'Mô tả', align: 'center' },
  { id: 'type', label: 'Đối tượng', align: 'center' },
  { id: 'status', label: 'Trạng thái', align: 'center' },
  { id: 'action', label: 'Action', align: 'center' },
];

export const DEFAULT_SEARCH_VALUE: IGroupPolicySearchParams = {
  searchText: '',
  type: '',
  status: '',
};
